angular.module('acme.view.application.importExport.jobExecution.controllers.importExportJobExecutionController', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.dataGrid',
  'acme.common.service.permissions',
  'acme.view.application.importExport.jobExecution.directives.importExportJobExecutionFileUpload',
  'acme.view.application.importExport.jobExecution.directives.importExportJobExecutionErrorGrid',
])
.controller('ImportExportJobExecutionController', ImportExportJobExecutionController);

/**
 * Controller responsible for loading a Import / Export Job
 * @class ImportExportJobExecutionController
 * @constructor
 * @param $window
 * @param $uibModal
 * @param $document
 * @param $q
 * @param {Object} $rootScope - angular's $rootScope service
 * @param {Object} $state - ui router state
 * @param ImportJobsApiService
 * @param ImportJobExecutionsApiService
 * @param JOB_EXECUTION_ACTIVE_STATUSES
 * @param JOB_EXECUTION_ERROR_CODES
 * @param JOB_EXECUTION_ERROR_TYPES
 * @param JOB_EXECUTION_ERROR_STATUSES
 * @param JOB_EXECUTION_STATUS_TITLE
 * @return {ImportExportJobExecutionController} - Class instance
 */
function ImportExportJobExecutionController(
  $window,
  $uibModal,
  $document,
  $q,
  $timeout,
  $scope,
  $rootScope,
  $state,
  ImportJobsApiService,
  ImportJobExecutionsApiService,
  JOB_EXECUTION_ACTIVE_STATUSES,
  JOB_EXECUTION_ERROR_CODES,
  JOB_EXECUTION_ERROR_TYPES,
  JOB_EXECUTION_ERROR_STATUSES,
  JOB_EXECUTION_STATUS_TITLE
) {
  Object.assign(this, {
    $window: $window,
    $uibModal: $uibModal,
    $document: $document,
    $q: $q,
    $timeout: $timeout,
    $scope: $scope,
    $rootScope: $rootScope,
    $state: $state,
    ImportJobsApiService: ImportJobsApiService,
    ImportJobExecutionsApiService: ImportJobExecutionsApiService,
    JOB_EXECUTION_ACTIVE_STATUSES: JOB_EXECUTION_ACTIVE_STATUSES,
    JOB_EXECUTION_ERROR_CODES: JOB_EXECUTION_ERROR_CODES,
    JOB_EXECUTION_ERROR_TYPES: JOB_EXECUTION_ERROR_TYPES,
    JOB_EXECUTION_ERROR_STATUSES: JOB_EXECUTION_ERROR_STATUSES,
    JOB_EXECUTION_STATUS_TITLE: JOB_EXECUTION_STATUS_TITLE
  });

  // TODO: update ui-router to 0.3.0 to avoid calling this manually
  this.$onInit();
}

/**
 * Angular lifecycle method $onInit
 * @public
 * @memberOf ImportExportJobExecutionController
 * @return {Undefined} -
 */
ImportExportJobExecutionController.prototype.$onInit = function () {

  var self = this,
    tab = this.$state.params.tab || 'logs',
    tableTemplate = {
      name: '',
      reUpload: false
    },
    // The tables we're currently expecting from the Import Job Execution response
    tableNames = {
      addresses: 'Addresses', contacts: 'Contacts', customerAttributes: 'Customer Attributes', customers: 'Customers',
      items: 'Items', memberships: 'Memberships', membershipTypes: 'Membership Types',
      membershipCards: 'Membership Cards', orders: 'Orders', organizations: 'Organizations', organizationCategories: 'Organization Category',
      organizationContacts: 'Organization Contacts', organizationAddress: 'Organization Address', tickets: 'Tickets'
    };

  // Button css classes
  self.IN_PROGRESS = 'in-progress';
  self.SECONDARY = 'secondary';
  self.PRIMARY = 'primary';
  self.DISABLED = 'disabled';

  self.$scope.$on('OverlayStatus::stop', function (event, args) {
    self.stopExecuting();
  });

  self.tables = {};

  // Fill tables with tables + additional meta data for view
  Object.keys(tableNames).forEach(function (key) {
    self.tables[key] = Object.assign({}, tableTemplate, { name: tableNames[key] });
  });



  this.errorPaginationOptions = {
    pageNumber: 0,
    pageSize: 10,
    sort: null
  };

  this.vm = {
    tab: tab,
    isRefreshing: false,
    isStopping: false,
    job: {},
    jobExecution: {},
    tableKeys: Object.keys(self.tables),
    tables: self.tables,
    errors: {
      gridOptions: {
        enableSorting: false,
        paginationPageSizes: [],
        paginationPageSize: this.errorPaginationOptions.pageSize,
        paginationPageNumber: this.errorPaginationOptions.pageNumber,
        useExternalPagination: true,
        useExternalSorting: true,
        columnDefs: [
          {
            field: 'message',
            name: 'Error message',
            cellTemplate: '<div class="ui-grid-cell-contents" title="{{COL_FIELD}}">{{COL_FIELD}}</div>'
          },
          { field: 'row', width: 60 },
          {
            field: 'createdOn',
            name: 'Created On',
            cellTemplate: '<div class="ui-grid-cell-contents">' +
              '{{ (COL_FIELD | date: \'short\') || "Unavailable" }}' +
            '</div>'
          },
          {
            field: 'type',
            width: 80,
            cellTemplate: '<div class="ui-grid-cell-contents" title="{{ grid.appScope.getErrorTypeTitle(COL_FIELD) }}">' +
              '{{ grid.appScope.getErrorTypeTitle(COL_FIELD) }}' +
            '</div>'
          },
          {
            field: 'code',
            width: 200,
            cellTemplate: '<div class="ui-grid-cell-contents" title="{{ grid.appScope.getErrorCodeDescription(COL_FIELD)' +
            ' }}">' +
              '{{ grid.appScope.getErrorCodeTitle(COL_FIELD) }}' +
            '</div>'
          },
          {
            field: 'status',
            width: 150,
            cellTemplate: '<div class="ui-grid-cell-contents" title="{{ grid.appScope.getErrorStatusTitle(COL_FIELD) }}">' +
              '{{ grid.appScope.getErrorStatusTitle(COL_FIELD) }}<' +
            '/div>'
          },
          {
            field: 'source',
            width: 70,
            cellTemplate: '<div class="ui-grid-cell-contents import-export-job-execution-view-error-source" title="{{COL_FIELD}}" data-ng-click="grid.appScope.open(COL_FIELD)">View</div>'
          }
        ],
        onRegisterApi: function(gridApi) {

          self.vm.gridApi = gridApi;

          gridApi.core.on.sortChanged(null, function(grid, sortColumns) {

            if (sortColumns.length === 0) {
              self.errorPaginationOptions.sort = null;
            } else {
              self.errorPaginationOptions.sort = sortColumns[0].name + ',' + sortColumns[0].sort.direction;
            }

            self._loadErrors(self.vm.jobExecution.id, self.errorPaginationOptions);
          });

          gridApi.pagination.on.paginationChanged(
            null,
            function (newPage, pageSize) {
              self.errorPaginationOptions.pageNumber = newPage - 1; // 0-based index for paging
              self.errorPaginationOptions.pageSize = pageSize;

              self._loadErrors(self.vm.jobExecution.id, self.errorPaginationOptions);
            });
        },
        data: []
      },
      selected: null
    },
    available: {
      gridOptions: {
        enableSorting: false,
        columnDefs: [
          {
            field: 'typeName',
            name: 'Type',
            cellTemplate: '<div class="ui-grid-cell-contents" title="{{COL_FIELD}}">{{COL_FIELD.replace(\'Do\', \'\')}}</div>'
          },
          {
            field: 'count',
            name: 'Valid Records'
          },
          {
            field: 'imported',
            name: 'Imported to acme'
          }
        ],
        data: []
      },
      selected: null
    }
  };

  this.vm.errors.gridOptions.appScopeProvider = this;

  this.loading = false;

  this._load(this.$state.params.id);
};

ImportExportJobExecutionController.prototype._load = function (id) {
  this._loadJob(this.$state.params.jobId);
  this._loadJobExecution(id);
  this._loadErrors(id, this.errorPaginationOptions);
  this._loadAvailableRecords(id);
};

ImportExportJobExecutionController.prototype._loadJob = function (id) {
  var self = this;

  self.ImportJobsApiService.get(id)
    .then(function (response) {
      self.vm.job = response.data;

      var jobTypeTitle = self.vm.job.jobType === 'EXPORT' ? 'Export' : 'Import'; // TODO create lookup

      self.$rootScope.$broadcast('Application::contentTitleChange', {
        title: jobTypeTitle + ' Job Execution',
        buttonLeft: {
          label: 'Back',
          action: function () {
            window.history.back();
          }
        }
      });
    });
};

ImportExportJobExecutionController.prototype.uploadedCount = function (tokens) {
  var self = this;
  return tokens.split('|').map(function(token) {
    return !!self.vm.jobExecution[token];
  }).filter(function(isUploaded) {
      return isUploaded;
    }).length;
};

ImportExportJobExecutionController.prototype._loadJobExecution = function (id) {
  var self = this;

  return self.ImportJobExecutionsApiService.get(id)
    .then(function (response) {
      self.vm.jobExecution = response.data;


      var bypassInternalErrors = self.testStatus('validatedCompleteWithError') && (
              typeof self.vm.jobExecution.internalValidationPassPercentage === "undefined" ||
              self.vm.jobExecution.internalValidationPassPercentage === null ||
              self.vm.jobExecution.internalValidationPassPercentage > 0
          ),
          bypassExternalErrors = self.testStatus('externalValidatedCompleteWithError') && (
              typeof self.vm.jobExecution.externalValidationPassPercentage === "undefined" ||
              self.vm.jobExecution.externalValidationPassPercentage === null ||
              self.vm.jobExecution.externalValidationPassPercentage > 0
          );

      if (self.testStatus('staging')) {
        self.clsStage = self.IN_PROGRESS;
      } else if (self.testStatus('imported|staged|validated|externalValidated') || bypassInternalErrors || bypassExternalErrors) {
        self.clsStage = self.SECONDARY;
      } else if (self.testStatus('uploaded')) {
        self.clsStage = self.PRIMARY;
      } else {
        self.clsStage = self.DISABLED;
      }

      if (self.testStatus('validating')) {
        self.clsValidate = self.IN_PROGRESS;
      } else if (self.testStatus('validated|externalValidated|imported') || bypassInternalErrors || bypassExternalErrors) {
        self.clsValidate = self.SECONDARY;
      } else if (self.testStatus('staged')) {
        self.clsValidate = self.PRIMARY;
      } else {
        self.clsValidate = self.DISABLED;
      }

      if (self.testStatus('externalValidating')) {
        self.clsValidateAcme = self.IN_PROGRESS;
      } else if ((self.testStatus('validated|externalValidated|imported') || bypassInternalErrors || bypassExternalErrors) && self.uploadedCount("orders|items") > 0) {
        self.clsValidateAcme = self.testStatus('validated') || bypassInternalErrors ? self.PRIMARY : self.SECONDARY;
      } else {
        self.clsValidateAcme = self.DISABLED;
      }

      if (self.testStatus('importing')) {
        self.clsImport = self.IN_PROGRESS;
      } else if (self.testStatus('imported')) {
        self.clsImport = self.SECONDARY;
      } else if (self.testStatus('externalValidated') || ((self.testStatus('validated') || bypassInternalErrors) && self.clsValidateAcme === self.DISABLED) || bypassExternalErrors) {
        self.clsImport = self.PRIMARY;
      } else {
        self.clsImport = self.DISABLED;
      }

      self.vm.isStopping = self.vm.jobExecution.stopping;
    });
};

ImportExportJobExecutionController.prototype._loadErrors = function (id, paginationOptions) {
  var self = this;

  return self.ImportJobExecutionsApiService.errors(id, paginationOptions.pageNumber, paginationOptions.pageSize, paginationOptions.sort)
    .then(function (response) {
      self.vm.errors.gridOptions.data = response.data._embedded ? response.data._embedded.jobErrorVoList : [];
      self.vm.errors.gridOptions.totalItems = response.data.page.totalElements;
    });
};

ImportExportJobExecutionController.prototype._loadAvailableRecords = function (id) {
  var self = this;

  return self.ImportJobExecutionsApiService.available(id)
    .then(function (response) {
      self.vm.available.gridOptions.data = response.data;
    });
};

ImportExportJobExecutionController.prototype.getErrorTypeTitle = function(type) {
  return this.JOB_EXECUTION_ERROR_TYPES[type] || type;
};

ImportExportJobExecutionController.prototype.getErrorCodeTitle = function(code) {
  if (this.JOB_EXECUTION_ERROR_CODES[code]) {
    return this.JOB_EXECUTION_ERROR_CODES[code].title;
  }

  return code;
};

ImportExportJobExecutionController.prototype.getErrorCodeDescription = function(code) {
  if (this.JOB_EXECUTION_ERROR_CODES[code]) {
    return this.JOB_EXECUTION_ERROR_CODES[code].description;
  }

  return code;
};

ImportExportJobExecutionController.prototype.getErrorStatusTitle = function(status) {
  return this.JOB_EXECUTION_ERROR_STATUSES[status] || status;
};

ImportExportJobExecutionController.prototype.refresh = function () {
  var self = this;
  self.vm.isRefreshing = true;

  this.$rootScope.$broadcast('ImportExport::loadErrors', new Date());

  this.$q.all([
    this._loadJobExecution(this.$state.params.id),
    this._loadErrors(this.$state.params.id, this.errorPaginationOptions),
    this._loadAvailableRecords(this.$state.params.id)
  ])
    .then(function () {
      self.vm.isRefreshing = false;
      console.log('refresh status', self.vm.jobExecution.status);

      if (self.testStatus('staging|validating|externalValidating|importing') || self.isUploading) {
       var status = self.getStatusTitle(self.vm.jobExecution.status);

       if (self.isUploading) {
         status = JOB_EXECUTION_STATUS_TITLE.uploading;
       }

        self.$rootScope.$broadcast('Application::setOverlayStatus', status);

        self.$timeout(function() {
          self.refresh();
        }, 1000);
      } else {
        self.$rootScope.$broadcast('Application::setOverlayStatus', null);
      }

    }, function () {
      console.log('refresh status error', self.vm.jobExecution.status);
      self.vm.isRefreshing = false;
    });
};

ImportExportJobExecutionController.prototype.updateTable = function (tableKey, filename) {

  var self = this,
    jobExecution = angular.copy(self.vm.jobExecution);

  jobExecution[tableKey] = filename;

  jobExecution.status = 'uploaded';

  self.ImportJobExecutionsApiService.update(jobExecution)
    .then(function () {
      self.vm.jobExecution[tableKey] = filename;
      self.tables[tableKey].reUpload = false;
      self.isUploading = false;
    });

  self.isUploading = true;
  self.$timeout(function() {
    self.refresh();
  }, 1000);

};

ImportExportJobExecutionController.prototype.getStatusTitle = function () {
  if (this.vm.isStopping) {
    return 'Stopping...';
  } else {
    var status = this.JOB_EXECUTION_STATUS_TITLE[this.vm.jobExecution.status];

    return status || this.JOB_EXECUTION_STATUS_TITLE.unknown;
  }
};

ImportExportJobExecutionController.prototype.getTableTitle = function (table) {
  return this.tables[table].name || 'Unknown Table';
};

ImportExportJobExecutionController.prototype.isActiveTab = function (tab) {
  return this.vm.tab === tab;
};

ImportExportJobExecutionController.prototype.setTab = function (tab) {
  this.vm.tab = tab;
};

ImportExportJobExecutionController.prototype.open = function (error) {
  var self = this,
    parentElem = angular.element(this.$document[0].querySelector('.import-export-job-execution'));

  var modalInstance = this.$uibModal.open({
    templateUrl: 'jobExecutionErrorModal.html',
    controller: ['error', function (error) {
      this.error = error;
    }],
    controllerAs: '$ctrl',
    appendTo: parentElem,
    resolve: {
      error: function () {
        return error;
      }
    }
  });
};

ImportExportJobExecutionController.prototype.testStatus = function (statuses) {
  return new RegExp('^(' + statuses + ')$','i').test(this.vm.jobExecution.status);
};

ImportExportJobExecutionController.prototype.hasUploadedFiles = function () {
  var self = this;

  // Not loaded yet
  if (!self.vm.jobExecution.id) {
    return false;
  }

  return self.vm.tableKeys.filter(function (tableKey) {
    return self.vm.jobExecution[tableKey] !== null;
  }).length > 0;
};

// TODO Determine states / order that we can validate data
// i.e. consider multiple upload iterations, Mappings updates, etc

ImportExportJobExecutionController.prototype.canValidateData = function () {
  var self = this;

  // TODO TEMP
  return self.hasUploadedFiles();

  // return self.JOB_EXECUTION_STATUS_TITLE[self.vm.jobExecution.status] === self.JOB_EXECUTION_STATUS_TITLE.staged;
};

ImportExportJobExecutionController.prototype.canValidateDataExternally = function () {
  var self = this;

  // TODO TEMP
  return self.hasUploadedFiles();

  // return self.JOB_EXECUTION_STATUS_TITLE[self.vm.jobExecution.status] === self.JOB_EXECUTION_STATUS_TITLE.validated;
};

ImportExportJobExecutionController.prototype.canImportData = function () {
  var self = this;

  // TODO TEMP
  return self.hasUploadedFiles();

  // return self.JOB_EXECUTION_STATUS_TITLE[self.vm.jobExecution.status] === self.JOB_EXECUTION_STATUS_TITLE.externalValidated;
};

ImportExportJobExecutionController.prototype.stage = function () {

  if (this.JOB_EXECUTION_STATUS_TITLE[this.vm.jobExecution.status] !== this.JOB_EXECUTION_STATUS_TITLE.uploaded) {
    if (!this.$window.confirm('Are you sure you would like to re-stage?')) {
      return;
    }
  }

  this.ImportJobExecutionsApiService.stage(this.$state.params.id)
    .then(this.refresh.bind(this));
};

ImportExportJobExecutionController.prototype.validate = function () {
  this.ImportJobExecutionsApiService.validate(this.$state.params.id)
    .then(this.refresh.bind(this));
};

ImportExportJobExecutionController.prototype.validateExternally = function () {
  this.ImportJobExecutionsApiService.validateExternally(this.$state.params.id)
    .then(this.refresh.bind(this));
};

ImportExportJobExecutionController.prototype.importData = function () {
  this.ImportJobExecutionsApiService.importData(this.$state.params.id)
    .then(this.refresh.bind(this));
};

ImportExportJobExecutionController.prototype.isActive = function (currentStatus) {
  return this.JOB_EXECUTION_ACTIVE_STATUSES.indexOf(currentStatus) > -1;
};

ImportExportJobExecutionController.prototype.stopExecuting = function () {
  var self = this;
  self.vm.isStopping = true;

  this.ImportJobExecutionsApiService.stop(this.$state.params.id)
    .then(function () {
      self.refresh();
    }, function () {
      self.$window.alert('There was an error stopping the execution of this job.');
    });
};

ImportExportJobExecutionController.prototype.getDownloadUrl = function (type) {
  return this.ImportJobExecutionsApiService.getDownloadUrl(this.vm.jobExecution.id, type);
};

ImportExportJobExecutionController.prototype.downloadFile = function ($event, id) {
  $event.preventDefault();

  this.$window.open(this.getDownloadUrl(id));
};

ImportExportJobExecutionController.$inject = [
  '$window',
  '$uibModal',
  '$document',
  '$q',
  '$timeout',
  '$scope',
  '$rootScope',
  '$state',
  'ImportJobsApiService',
  'ImportJobExecutionsApiService',
  'JOB_EXECUTION_ACTIVE_STATUSES',
  'JOB_EXECUTION_ERROR_CODES',
  'JOB_EXECUTION_ERROR_TYPES',
  'JOB_EXECUTION_ERROR_STATUSES',
  'JOB_EXECUTION_STATUS_TITLE'
];